var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.1,
    height: 27.1,
    viewBox: "0 0 27.1 27.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.55,0A13.55,13.55,0,1,0,27.1,13.55,13.57,13.57,0,0,0,13.55,0ZM6.29,23.14A7.4,7.4,0,0,1,10,18.27a5.44,5.44,0,0,0,3.53,1.33,5.52,5.52,0,0,0,3.56-1.35,7.11,7.11,0,0,1,1.81,1.33,7.41,7.41,0,0,1,2,3.51,12,12,0,0,1-14.6.05Zm7.26-5c-2.46,0-4.45-2.36-4.45-5.25s2-5.25,4.45-5.25S18,10,18,12.85,16,18.1,13.55,18.1ZM22.15,22a9.3,9.3,0,0,0-4-4.88,7.3,7.3,0,0,0,1.33-4.25c0-3.72-2.67-6.75-5.95-6.75s-6,3-6,6.75A7.28,7.28,0,0,0,9,17.14,8.92,8.92,0,0,0,5,22.06,12,12,0,1,1,22.15,22Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.67dc974349f472f10c9ec9619d3554b5.svg";
export { ForwardRef as ReactComponent };